<template>
  <IndividualSummaryOverlay />
</template>
<script>
  import IndividualSummaryOverlay from 'features/measureLiveDiscussion/individualSummaryOverlay.vue';
  export default {
    components: {
      IndividualSummaryOverlay,
    },
  };
</script>



// WEBPACK FOOTER //
// LDIndividualSummaryTab.vue?8d77e8e4